<div class="form">
  <form [formGroup]="formGroup()" class="form-container">
    <div class="form-fields">
      <ng-content></ng-content>
    </div>
  </form>
</div>
